export default { sha: '3d915de96a3d56f7298c636f8b4a6c16026ae50e', buildNumber: 'undefined' }
